function getProfessionName(professions, profession) {
  if (!profession) {
    return 'Dental Hygienist';
  }
  	return professions.filter((el) => el.code === profession).map((el) => el.name)[0];
}

function getProfessionCode(professions, professionType) {
  	return professions
    .filter((el) => el.name === professionType)
    .map((el) => el.code)[0];
}

const handleConfirmRemoveDate = (jobDates, deletedDate) => {
  const jobData = {};
  const datesFilteredArr = jobDates.filter((date) => date !== deletedDate);
  datesFilteredArr.forEach((date) => {
    jobData[date] = {};
  });
  return jobData;
};

const sortDates = (dates) => {
  const sortedDates = dates.map((date) => new Date(date)).sort((a, b) => a - b);
  return sortedDates.map((date) => date.toISOString().slice(0, 10));
};

export {
  getProfessionCode, getProfessionName, handleConfirmRemoveDate, sortDates
};
